import { render, staticRenderFns } from "./simplifyOweFee.vue?vue&type=template&id=4404a43c&scoped=true"
import script from "./simplifyOweFee.vue?vue&type=script&lang=js"
export * from "./simplifyOweFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyOweFee.vue?vue&type=style&index=0&id=4404a43c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4404a43c",
  null
  
)

export default component.exports